exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".payment-success-container[data-v-328703b5]{min-height:100vh;background:linear-gradient(135deg,#667eea,#764ba2)}.payment-success-container>div[data-v-328703b5]{background:transparent}.payment-success-container .max-w-md[data-v-328703b5]{background:#fff;border-radius:8px;padding:2rem;-webkit-box-shadow:0 20px 25px -5px rgba(0,0,0,.1),0 10px 10px -5px rgba(0,0,0,.04);box-shadow:0 20px 25px -5px rgba(0,0,0,.1),0 10px 10px -5px rgba(0,0,0,.04)}", ""]);

// exports
